import { TSelectItemDialogState } from '@modules/items';
import { Dispatch, SetStateAction } from 'react';

type SetDialog = Dispatch<SetStateAction<TSelectItemDialogState | undefined>>;

export const openDialog = (setState: SetDialog, onSelect: TSelectItemDialogState['onSelect']) =>
  setState((prev) => (prev ? { ...prev, isOpen: true, onSelect } : prev));

export const resetDialog = (setState: SetDialog) =>
  setState((prev) => (prev ? { ...prev, isOpen: false, onSelect: (_) => Promise.resolve() } : prev));
